export default "__VITE_ASSET__DpZ2gVat__"